import { inject, Injectable } from '@angular/core';
import { AuthService } from '@tokenbox/services';
import type { User } from '@supabase/supabase-js';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppAuthService extends AuthService {
  private router = inject(Router);

  public override async tryLoggingIn(): Promise<User | null> {
    const user = await super.tryLoggingIn();
    if (!user) {
      void this.router.navigate(['/auth/login']);
    }
    return user;
  }
}
